import * as prettier from 'prettier';
import type { Lang } from '.';
import { Ok } from '../blocks/ts/result';
const format: Lang['format'] = async (code, { formatter, prettierOptions, filePath }) => {
	if (!formatter) return code;

	if (formatter === 'prettier') {
		return await prettier.format(code, {
			parser: 'markdown',
			filepath: filePath,
			...prettierOptions
		});
	}

	return code;
};

/** Language support for `*.(mdc)` files. */
export const cursorRules: Lang = {
	matches: (fileName) => fileName.endsWith('.mdc'),
	resolveDependencies: () => Ok({ dependencies: [], local: [], devDependencies: [], imports: {} }),
	format
};
